//Ordenes de compra y solicitudes ERP UM Panamá
export const newOrdersAdapter = (orders) => {
    return {
        orders: orders.map((order) => {
            return {
                id: order.id,
                name: order.name,
                createDate: order.load_date || '-',
                type: order.type || '-',
                state: order.invoice_ids[0]?.payment_state || 'A Autorizar',
                ref: order.ref || '-',
                company: order.company || '-',
                responsible: order.responsible || '-',
                amount: order.amount || 0,
                currency: order.currency || 'USD',
                activityDate: order.activity_date || '-',
                typeId: order.type_id || null,
                typeIdName: order.type_id_name || '-',
                invoiceIds: order.invoice_ids ?? [],
                paymentDate: order.payment_date || '-',
                effectivePaymentDate: order.effective_payment_date || '-',
                comments: order.comments || '-',
                description: order.description || '-',
            };
        }),
    };
};
